<template>
  <div
    class="tabs"
    :data-current-tab="activeItem"
    :data-current-counter="activeItemCounter">
    <div class="tabs-items">
      <ul v-if="isDesktop">
        <li
          v-for="(item, index) in filteredItems"
          :class="{ 'active': item.id === activeItem}"
          :key="'t-' + index"
          @click="toggle(item.id)">
          {{ item.name }}
          <counter
            v-if="item.counter"
            :value="item.counter" />
        </li>
      </ul>

      <div
        v-if="isMobile || isTablet"
        class="select-wrapper">
        <select
          @change="toggleItem"
          v-model="activeItem">
          <option
            v-for="(item, index) in filteredItems"
            :class="{ 'active': item.id === activeItem}"
            :key="'t-' + index"
            :value="item.id">
            {{ item.name }}
            <template v-if="item.counter"> ({{ item.counter }})</template>
          </option>
        </select>
      </div>
    </div>

    <div class="tabs-content">
      <div :class="{ 'tab': true, 'is-active': true}">
        <slot :name="'tab-' + activeIndex"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Responsive from './../mixins/Responsive';
import Vue from 'vue';

export default {
  name: 'tabs',
  mixins: [
    Responsive
  ],
  props: {
    id: {
      default: '',
      type: String
    },
    items: {
      default: () => [],
      type: Array
    },
    onToggle: {
      default: () => false,
      type: Function
    },
    storageType: {
      default: 'sessionStorage',
      type: String
    }
  },
  data () {
    return {
      activeItem: false
    }
  },
  computed: {
    activeItemCounter: function () {
      let selectedItem = this.items.filter(item => item.id === this.activeItem);

      if (selectedItem.length) {
        return selectedItem[0].counter;
      }

      return 0;
    },
    activeIndex () {
      let activeIndex = 0;

      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].id === this.activeItem) {
          activeIndex = this.items[i].id;
        }
      }

      return activeIndex;
    },
    filteredItems () {
      return this.items.filter(item => typeof item.isVisible === 'undefined' || !!item.isVisible);
    }
  },
  watch: {
    items (loadedItems) {
      let lastOpenedTab = window[this.storageType].getItem(this.id);
      let tabIDs = this.items.map(item => item.id);

      if (lastOpenedTab && tabIDs.indexOf(lastOpenedTab) > -1) {
        Vue.set(this, 'activeItem', lastOpenedTab);
      } else if (loadedItems[0]) {
        Vue.set(this, 'activeItem', loadedItems[0].id || false);
      }
    }
  },
  methods: {
    toggle (newActiveItem) {
      this.activeItem = newActiveItem;
      this.onToggle(newActiveItem);

      if (this.id !== '') {
        window[this.storageType].setItem(this.id, newActiveItem);
      }
    },
    toggleItem (e) {
      let newActiveItem = e.target.value;
      this.toggle(newActiveItem);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.tabs {
  &-items {
    background: $color-light;
    user-select: none;

    ul {
      display: flex;
      list-style-type: none;
      margin: 0 auto;
      max-width: 1400px;
      padding: 0 3.6rem;

      li {
        color: $color-link;
        cursor: pointer;
        height: 6rem;
        line-height: 6rem;
        margin-right: 5rem;
        position: relative;

        &.active {
          &:after {
            background: $color-link;
            bottom: 0;
            content: "";
            height: 3px;
            left: 0;
            position: absolute;
            width: 100%;
          }
        }
      }
    }

    .select-wrapper {
      align-items: center;
      display: flex;
      height: 6rem;
      line-height: 6rem;
      list-style-type: none;
      margin: 0 auto;
      max-width: 1400px;
      padding: 0 3.6rem;
    }
  }

  &-content {
    margin: 3.6rem auto;
    max-width: calc(1400px - 7.2rem);
    position: relative;
    z-index: 1;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all .25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 1680px) {
  .tabs {
    &-items {
      ul {
        li {
          margin-right: 3rem;
        }
      }
    }
  }
}

@media (max-width: 1450px) {
  .tabs-content {
    margin: 3.6rem;
  }
}

@media (max-width: 1240px) {
  .tabs {
    &-items {
      ul,
      .select-wrapper {
        padding: 0 1.5rem;
      }
    }

    &-content {
      margin: 3.6rem 1.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Tabs.vue